<template>
  <table class="table table-striped border-top-0 border-bottom">
    <thead class="border-top-0">
      <tr>
        <th>SKU</th>
        <th>UPC</th>
        <th>Description</th>
        <th>Location</th>
        <th>Qty</th>
        <th>Picked</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="inv in inventory" :key="inv.id">
        <td>
          {{ inv.sku }}
        </td>
        <td>{{ inv.upc }}</td>
        <td>{{ inv.name }}</td>
        <td><span v-if="inv.parent_bin_name">{{ inv.parent_bin_name}} / </span>{{ inv.bin_name}}</td>
        <td>{{ inv.qty }}</td>
        <td>{{ inv.qty_picked }}</td>
      </tr>
      <tr v-if="order.allocated_inventory.length == 0">
        <td colspan="4" class="text-center">No inventory allocated to this order.</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'items-tab',
  props: {
    order: Object,
  },

  computed: {
    inventory() {
      return this.order.allocated_inventory.filter(inv => !inv.kit)
    }
  }
}
</script>